var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.notice)?_c('div',{class:['notification', _vm.notice.status]},[_c('span',{domProps:{"textContent":_vm._s(_vm.notice.message)}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }